var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemperatureIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2353_93252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 11.243V4C19 2.93913 18.5786 1.92172 17.8284 1.17157C17.0783 0.421427 16.0609 0 15 0C13.9391 0 12.9217 0.421427 12.1716 1.17157C11.4214 1.92172 11 2.93913 11 4V11.243C9.77702 12.0946 8.85772 13.3142 8.37592 14.7245C7.89412 16.1347 7.87496 17.6619 8.32123 19.0838C8.7675 20.5056 9.6559 21.748 10.8571 22.63C12.0584 23.512 13.5097 23.9876 15 23.9876C16.4903 23.9876 17.9416 23.512 19.1429 22.63C20.3441 21.748 21.2325 20.5056 21.6788 19.0838C22.125 17.6619 22.1059 16.1347 21.6241 14.7245C21.1423 13.3142 20.223 12.0946 19 11.243ZM15 21C13.9391 21 12.9217 20.5786 12.1716 19.8284C11.4214 19.0783 11 18.0609 11 17H19C19 18.0609 18.5786 19.0783 17.8284 19.8284C17.0783 20.5786 16.0609 21 15 21Z",
    fill: "#063554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2H2V4H8V2Z",
    fill: "#063554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7H2V9H8V7Z",
    fill: "#063554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12H2V14H6V12Z",
    fill: "#063554"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2353_93252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureIcon);
export default __webpack_public_path__ + "static/media/temperature-icon.44f4064dc1ac49ebf21f253592a668c1.svg";
export { ForwardRef as ReactComponent };